/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
/* eslint-disble max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable object-curly-newline */

import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { faSearch, faBuilding, faLock, faEnvelope, faBarcode, faKey } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { searchPlantForReset, updatePlantPassword } from '../../store/modules/user/actions';
import LoadingModal from '../../components/LoadingModal';

import './ResetPlantPassword.scss';

const ResetPlantPassword = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);
  const plant = useSelector((state) => state.user.plant);
  const [searchMethod, setSearchMethod] = useState('plantCode');

  const {
    register: registerSearch, handleSubmit: handleSearchSubmit, formState: { errors: searchErrors },
  } = useForm();

  const {
    register: registerUpdate,
    handleSubmit: handleUpdateSubmit,
    reset: resetUpdate,
    formState: { errors: updateErrors },
  } = useForm();

  const onSearch = (data) => {
    const query = {};
    if (searchMethod === 'plantCode') {
      query.plantCode = data.plantCode;
    } else if (searchMethod === 'plantName') {
      query.plantName = data.plantName;
    } else if (searchMethod === 'email') {
      query.email = data.email;
    }
    dispatch(searchPlantForReset(query));
  };

  const onUpdate = (data) => {
    const payload = {
      ...data,
    };
    if (plant && plant._id) payload.plantId = plant._id;
    if (plant && plant.id) payload.plantId = plant.id;
    if (plant && plant.email) payload.email = plant.email;

    dispatch(updatePlantPassword(payload, () => {
      resetUpdate();
    }));
  };

  return (
    <>
      <div className="reset-plant-password">
        <div className="row">
          <div className="col-12">
            <div className="reset-header">
              <h2 className="reset-header__title">
                Reset Plant Password
              </h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-lg-6 col-md-8 mx-auto">
            <div className="reset-card">

              {/* Search Section */}
              <div className="reset-section">
                <div className="reset-section__header">
                  <h4><FontAwesomeIcon icon={faSearch} /> Find Plant Account</h4>
                </div>

                <div className="form__item mb-4">
                  <label htmlFor="searchMethod" className="form__label">Search Method</label>
                  <select id="searchMethod" className="form__field custom-select-modern" value={searchMethod} onChange={(e) => setSearchMethod(e.target.value)}>
                    <option value="plantCode">Plant Code</option>
                    <option value="plantName">Plant Name</option>
                    <option value="email">Email Address</option>
                  </select>
                </div>

                <div className="form__item">
                  <label className="form__label">
                    {searchMethod === 'plantCode' ? 'Enter Plant Code' : searchMethod === 'plantName' ? 'Enter Plant Name' : 'Enter Email Address'}
                  </label>
                  <div className="input-group-modern">
                    <input
                      className="form__field"
                      type={searchMethod === 'email' ? 'email' : 'text'}
                      placeholder={`e.g. ${searchMethod === 'email' ? 'plant@heritage.com' : '1024'}`}
                      {...registerSearch(searchMethod, {
                        required: { value: true, message: 'This field is required' },
                      })}
                    />
                  </div>
                  {searchErrors[searchMethod] && <div className="form__error">{searchErrors[searchMethod].message}</div>}
                </div>

                <div className="action-row mt-4">
                  <button type="button" className="button-modern btn-search" onClick={handleSearchSubmit(onSearch)}>
                    Search Plant
                  </button>
                </div>
              </div>

              {/* Update Password Section */}
              {plant && (
                <div className="reset-section animate-fade-in mt-4">
                  <div className="divider" />

                  <div className="plant-info-card">
                    <div className="plant-avatar">
                      <FontAwesomeIcon icon={faBuilding} />
                    </div>
                    <div className="plant-details">
                      <h4 className="plant-name">{plant.plantName}</h4>
                      <div className="plant-meta">
                        <span className="meta-item"><FontAwesomeIcon icon={faBarcode} /> <strong>Code:</strong> {plant.plateCode || plant.plantCode || 'N/A'}</span>
                        <span className="meta-item"><FontAwesomeIcon icon={faEnvelope} /> <strong>Email:</strong> {plant.email || 'N/A'}</span>
                      </div>
                    </div>
                  </div>

                  <div className="form__item mt-5">
                    <label className="form__label">New Security Password</label>
                    <div className="input-group-modern">
                      <span className="input-icon">
                        <FontAwesomeIcon icon={faKey} />
                      </span>
                      <input
                        className="form__field pl-5"
                        type="text"
                        id="password"
                        name="password"
                        placeholder="Enter the new password"
                        {...registerUpdate('password', {
                          required: { value: true, message: 'Password is required' },
                        })}
                      />
                    </div>
                    {updateErrors.password && <div className="form__error">{updateErrors.password.message}</div>}
                  </div>

                  <div className="action-row mt-4">
                    <button type="button" className="button-modern btn-update" onClick={handleUpdateSubmit(onUpdate)}>
                      <FontAwesomeIcon icon={faLock} /> Update Credentials
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
      <LoadingModal show={isLoading} />
    </>
  );
};

export default ResetPlantPassword;
